import angular from 'angular';
import constants from 'app/constants';
import {
  loaderService,
  ssDialogService,
  userService,
  vmDataService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './edit-custom-risk-control-question-dialog.controller';
import template from './edit-custom-risk-control-question-dialog.html';

// Validation
import customRiskControlQuestionDisplayQuestionMessagesTpl
  from '../dialog.editCustomRiskControlDialog/custom-risk-control-question-display-question.messages.html';


class dialogService {
  getOptions($event, {
    customRiskControl, parentRiskControlQuestion, riskControlQuestion, addCallback
  }) {
    return {
      controller,
      controllerAs: 'editCustomRiskControlQuestionDialogVM',
      locals: {
        customRiskControl,
        parentRiskControlQuestion,
        riskControlQuestion,
        addCallback
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.vendorManagement.editCustomRiskControlQuestionDialog', [
  alerts,
  constants,
  loaderService,
  ssDialogService,
  userService,
  vmDataService,
])
  .service('editCustomRiskControlQuestionDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put(
      'custom-risk-control-question-display-question.messages.html',
      customRiskControlQuestionDisplayQuestionMessagesTpl
    );
  })
  .name;
